import styled from 'styled-components';

import { colors } from 'constants/colors';

const adminGunder = process.env.REACT_APP_PROXY || '/';

const Footer: React.FC = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <nav className="footer-nav text-align-center">
            <Ul>
              <Li>
                <Link href="mailto:fundportaladmin@gunder.com">
                  Questions/Support
                </Link>
              </Li>
              <Li>
                <Link
                  href="https://www.gunder.com/en/legal-notices-and-attorney-advertising"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Legal Notices & Attorney Advertising
                </Link>
              </Li>
              <Li>
                <Link
                  href={`${adminGunder}/terms`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Terms of Use
                </Link>
              </Li>
              <Li>
                <Link
                  href={`${adminGunder}/privacy`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Privacy Policy
                </Link>
              </Li>
            </Ul>
          </nav>
          <Copyright>
            <p>
              Gunderson Dettmer Stough Villeneuve Franklin & Hachigian, LLP{' '}
              <br />
              Copyright {new Date().getFullYear()}. All Rights Reserved
            </p>
          </Copyright>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  background-color: ${colors.dark.backgroundGrey};
  color: ${colors.dark.black};
  display: flex;
  flex-direction: row;
  font-size: 14px;
  justify-content: center;
  margin-top: auto;
  padding-bottom: 15px;
  padding-top: 25px;
  width: 100%;
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 20px;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
`;

const Li = styled.li`
  color: ${colors.dark.green};
  :hover {
    color: ${colors.dark.gray};
  }
`;

const Link = styled.a`
  color: inherit;
  text-decoration: none;
  &:hover {
    color: ${colors.dark.gray};
    text-decoration: underline;
  }
`;

const Copyright = styled.div`
  font-size: 14px;
  line-height: 25px;
  margin-bottom: 0;
  margin-top: 10px;
  text-align: center;
`;

export default Footer;
